import { AnimatePresence, motion } from "framer-motion";

const BottomSheet = ({ children, height = "285px", show = true, onClose, loading, onSave }) => {
    if (!show) return null;

    return (
        <AnimatePresence>
            {show && (
                <>
                    {/* Background Overlay */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 0.5 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        onClick={(e) => onClose(e, true)}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            maxWidth: "100vw",
                            overflowX: "hidden",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            zIndex: 1,
                        }}
                    />

                    {/* Bottom Sheet */}
                    <motion.div
                        initial={{ y: "100%" }}
                        animate={{ y: "0%" }}
                        exit={{ y: "100%" }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                        style={{
                            position: "fixed",
                            bottom: 0,
                            width: "100%",
                            minHeight: height,
                            zIndex: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            left: 0,
                        }}
                    >
                        <button className="ios-picker-close-btn bg-wafaa-white-2 text-blue-white" onClick={onClose}>
                            ✕
                        </button>
                        <div
                            className="bg-wafaa-white-2 text-blue-white"
                            style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "12px 12px 0px 0px",
                                boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.1)",
                                // background: "linear-gradient(to top, #ffffff 0%, #f0f0f0 100%)",
                                display: "flex",
                                flexDirection: "column",
                                padding: "2rem 1rem 1rem 1rem",
                                overflowY: "auto",
                            }}
                        >
                            {children}

                            {/* Optional Done Button */}

                            <button
                                disabled={loading}
                                onClick={onSave}
                                style={{
                                    marginTop: "1rem",
                                    height: "44px",
                                    width: "100%",
                                    borderRadius: "6px",
                                    backgroundColor: loading ? "#ccc" : "#2C3691",
                                    color: "white",
                                    border: "none",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    cursor: "pointer",
                                    textTransform: "uppercase",
                                }}
                            >
                                {loading ? "Updating..." : "Update Changes"}
                            </button>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default BottomSheet;
